import { detectBrowser } from '@/_services/broswerType'
const broswerType = detectBrowser()
export const headers = {
    'Content-Type': 'application/json',
    APPID: 'TEST',
    APPKEY: 'TEST',
    DeviceType: broswerType,
    DeviceId: '',
    UserAccountProfile: '',
    REMOTE_ADDR: ''
}